<template>
  <div class="display--flex align-items--center fr-mb-3w">
    <RiCheckboxCircleLine
      color="var(--primary)"
      size="20px"
      class="fr-mr-1w no-shrink"
      aria-hidden="true"
    />
    <h2 class="fr-text--md fr-text--regular fr-mb-0">{{ label }}</h2>
    <DfButton tertiary-no-outline class="fr-ml-auto" :disabled="disabled" @click="$emit('click')">
      {{ t('edit') }} <RiArrowGoBackLine size="1rem" class="fr-ml-1w" aria-hidden="true" />
    </DfButton>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { RiArrowGoBackLine, RiCheckboxCircleLine } from '@remixicon/vue'
import { useI18n } from 'vue-i18n'
import DfButton from 'df-shared-next/src/Button/DfButton.vue'

const { label, disabled = false } = defineProps<{
  label: string
  disabled?: boolean
}>()

defineEmits<{ click: [] }>()
const { t } = useI18n()
</script>

<style scoped>
.no-shrink {
  flex-shrink: 0;
}
</style>

<i18n>
{
  "en": {
    "edit": "Edit",
  },
  "fr": {
    "edit": "Modifier",
  }
}
</i18n>
